var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrescoDialogLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1034,
    height: 135.614,
    viewBox: "0 0 1034 135.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_391",
    "data-name": "Rectangle 391",
    width: 1034,
    height: 135.614,
    transform: "translate(35 655.43)",
    fill: "rgba(255,255,255,0.5)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_28",
    "data-name": "Mask Group 28",
    transform: "translate(-35 -655.43)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357",
    transform: "translate(21.447 655.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6994",
    "data-name": "Path 6994",
    d: "M73.216,118.634c-22.486,0-37.022-17.252-37.022-39.347,0-25.2,16.864-39.931,36.829-39.931,13.371,0,24.418,7.172,31.785,15.9L128.459,34.9A71.575,71.575,0,0,0,73.024,8.345c-45.36,0-70.945,31.592-70.945,70.942,0,45.745,31.595,70.361,71.137,70.361a70.848,70.848,0,0,0,55.435-26.168L105,103.127c-7.945,9.5-18.991,15.507-31.785,15.507",
    transform: "translate(-2.079 -8.345)",
    fill: "#60b7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6995",
    "data-name": "Path 6995",
    d: "M174.644,56.5c0-27.522-15.116-47.49-49.229-47.49H71.722V146.63h31.595V102.245h11.825l28.3,44.386h37.99L148.674,97.784c17.056-6.976,25.97-21.319,25.97-41.284M119.6,73.944h-16.28V37.5h16.864c14.536,0,20.934,7.752,20.934,18.221,0,11.434-7.56,18.221-21.517,18.221",
    transform: "translate(131.473 -7.072)",
    fill: "#60b7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6996",
    "data-name": "Path 6996",
    d: "M167.01,92.162h45.938V64.252H167.01V37.889h58.151V9.01H135.415V146.628h93.813V117.747H167.01Z",
    transform: "translate(253.609 -7.069)",
    fill: "#60b7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6997",
    "data-name": "Path 6997",
    d: "M252.8,63.469c-14.924-5.815-19.963-9.3-19.767-15.892,0-6.591,4.843-10.664,12.791-10.664,7.752,0,16.283,3.685,28.108,12.989l18.221-23.65C278.967,15.01,262.491,8.034,244.466,8.422,218.875,8.807,199.3,26.059,199.3,48.93c0,27.137,20.934,37.022,41.865,44.2,15.51,5.231,20.356,8.525,20.356,16.085,0,6.206-4.651,11.633-15.507,11.633-9.5,0-22.1-4.846-32.564-16.28l-19,23.064c14.728,15.119,32.955,21.906,50.592,21.906,22.868,0,50.589-11.633,50.589-44,0-26.556-18.606-32.759-42.837-42.063",
    transform: "translate(366.82 -8.226)",
    fill: "#60b7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6998",
    "data-name": "Path 6998",
    d: "M326.639,118.634c-22.486,0-37.022-17.252-37.022-39.347,0-25.2,16.864-39.931,36.827-39.931,13.377,0,24.42,7.172,31.79,15.9L381.882,34.9A71.576,71.576,0,0,0,326.444,8.345c-45.361,0-70.945,31.592-70.945,70.942,0,45.745,31.6,70.361,71.14,70.361a70.847,70.847,0,0,0,55.435-26.168l-23.65-20.353c-7.947,9.5-18.994,15.507-31.785,15.507",
    transform: "translate(483.886 -8.345)",
    fill: "#60b7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6999",
    "data-name": "Path 6999",
    d: "M391.008,8.345c-41.868,0-70.945,29.27-70.945,70.747s29.077,70.557,70.945,70.557c41.089,0,70.746-28.494,70.746-70.557,0-42.256-29.658-70.747-70.746-70.747m0,111.261c-21.711,0-37.022-18.028-37.022-40.514S369.3,38.583,391.008,38.583c21.316,0,36.826,17.637,36.826,40.508s-15.51,40.514-36.826,40.514",
    transform: "translate(607.696 -8.345)",
    fill: "#60b7e8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrescoDialogLogo);
export default __webpack_public_path__ + "static/media/CrescoDialogLogo.f00325ae8992eaaa974d60626de0df0d.svg";
export { ForwardRef as ReactComponent };